var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlcoholicDrinksPremium = function SvgAlcoholicDrinksPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.197 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.697 4.6a5.002 5.002 0 0 1 9.9 1 5 5 0 0 1-8.493 3.577M7.597 13.6v7m0-7L1.053 7.17C.095 6.229.76 4.6 2.104 4.6h10.994c1.343 0 2.009 1.63 1.05 2.57zm0 7h-3m3 0h3"
  })));
};
export default SvgAlcoholicDrinksPremium;